<template>
    <div v-if="isNotificationOpen" class="message" :class="styles">
        <div v-if="title" class="message-title">
            <h2>{{title}}</h2>
        </div>
        <div class="message-content">
            <slot name="content"></slot>
        </div>
        <r-button v-if="!this.permanent" @click="closeInlineNotification" class="btn-link"><r-icon icon="close"/></r-button>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';

    export default {
        name: 'v-inline-notifications',
        components: {vIcon},
        props: {
            title: {
                type: String,
                default: null,
            },
            type: {
                type: String,
                default: '',
                validator: type => ['', 'negative', 'positive', 'info', 'warning'].includes(type),
            },
            permanent: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isNotificationOpen: true,
            };
        },
        computed: {
            styles() {
                const style = {
                    'has-delete': !this.permanent,
                };
                if (this.type !== '') {
                    style[`message-${this.type}`] = true;
                }
                return style;
            },
        },
        methods: {
            closeInlineNotification() {
                this.isNotificationOpen = false;
            },
        },
    };
</script>
